var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.839112 7.99316C0.839112 8.27539 0.947022 8.51611 1.16284 8.73193L7.63745 15.0654C7.82007 15.248 8.04419 15.3394 8.30981 15.3394C8.84937 15.3394 9.28101 14.9243 9.28101 14.3848C9.28101 14.1191 9.1731 13.8784 8.99048 13.6875L3.14673 7.99316L8.99048 2.29883C9.1648 2.11621 9.28101 1.87549 9.28101 1.60986C9.28101 1.06201 8.84937 0.646973 8.30982 0.646973C8.04419 0.646973 7.82007 0.738281 7.63745 0.920898L1.16284 7.25439C0.938721 7.47021 0.839112 7.71094 0.839112 7.99316Z",
    fill: "#AAB2BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.06b66d27d53b34fafbcbd5da99090f63.svg";
export { ForwardRef as ReactComponent };